/* CRTD Collection — Revert to traditional scroll
   Kill scroll-snap behaviour, hide the scrubber UI, restore natural page scroll.
   Keep the editorial card layout (image + title + tagline + price + CTA).
*/
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var CSS = '\
  @media (max-width: 740px) {\
    html, body { scroll-snap-type: none !important; }\
    .crtd-swipe {\
      display: block !important;\
      height: auto !important;\
      max-height: none !important;\
      overflow: visible !important;\
      scroll-snap-type: none !important;\
      -webkit-overflow-scrolling: auto !important;\
      margin: 0 !important;\
      padding: 0 !important;\
    }\
    .crtd-swipe-card {\
      scroll-snap-stop: none !important;\
      scroll-snap-align: none !important;\
      height: auto !important;\
      min-height: 0 !important;\
      padding-bottom: 48px;\
    }\
    .crtd-swipe-img-wrap {\
      aspect-ratio: 1 / 1 !important;\
      max-height: none !important;\
    }\
    .crtd-swipe-scrubber { display: none !important; }\
  }\
  ';
  var style = document.createElement('style');
  style.id = 'crtd-swipe-revert';
  style.appendChild(document.createTextNode(CSS));
  document.head.appendChild(style);
})();

(function () {
  var css = '\
    .crtd-pcard-img-wrap {\
      padding: 22px !important;\
      aspect-ratio: 1 / 1 !important;\
      box-sizing: content-box !important;\
    }\
    @media (max-width: 740px) {\
      .crtd-pcard-img-wrap { padding: 14px !important; }\
    }\
    .crtd-pcard-img,\
    .crtd-swipe-img {\
      object-fit: contain !important;\
      object-position: center !important;\
      background: #faf9f7 !important;\
    }\
  ';
  var s = document.createElement('style');
  s.id = 'crtd-tile-image-fix';
  s.appendChild(document.createTextNode(css));
  document.head.appendChild(s);
})();
